<template>
    <div class="configurations" style="height:calc(98vh - 50px);">
        <!-- <div class="card" style="height:97%"> -->
        <div class="card" style="height:97">
            <div class="card-content">
                <b-tabs destroy-on-hide v-model="activeTab" @change="onTabChange">
                    <b-tab-item
                        :label="tab.name"
                        v-for="tab in configuration"
                        :key="tab.name"
                    />
                </b-tabs>
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>

    import { configurationPermissions } from "@/mixins/configurationPermissions";

    export default {
      mixins: [configurationPermissions],
      data: () => ({
        activeTab: 0
      }),
      created() {
        // Update active tab when user navigates via url
        const matched = this.$router.currentRoute.matched.map(route => route.name);
        const tab = this.configuration.findIndex(tab =>
          matched.includes(tab.route)
        );
        if (tab > -1) {
          this.activeTab = tab;
        } else {
          // If current route is /configuration, redirect to 1st tab route
          // Else if no tabs, redirect to start route
          if (this.configuration.length) {
            this.onTabChange(0);
          } else {
            this.$router.push({ name: this.$store.getters['Auth/startRoute'] });
          }
        }
      },
      methods: {
        onTabChange(tab) {
          if (this.configuration[tab]) {
            this.$router.push({ name: this.configuration[tab].route });
          }
        }
      }
    };

</script>

<style scoped>
    .scrollable {
        height: 100%;
        padding: 0;
    }
    .b-tabs:not(:last-child) {
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/Configurations/list/index.vue